import { useState } from 'react'
import { Button } from '../../design'
import { MEMBER_PASSWORD_COPY } from './passwordCopy'

export type RevealedPassword = { email: string; password: string }

type CopyState = 'idle' | 'copied' | 'failed'

export const PasswordReveal = ({ revealed, onDismiss }: { revealed: RevealedPassword; onDismiss: () => void }) => {
  const [copy, setCopy] = useState<CopyState>('idle')
  const copyPassword = async () => {
    try {
      await navigator.clipboard.writeText(revealed.password)
      setCopy('copied')
    } catch {
      setCopy('failed')
    }
  }
  return (
    <section className="password-reveal" aria-label={MEMBER_PASSWORD_COPY.revealTitle(revealed.email)}>
      <h3>{MEMBER_PASSWORD_COPY.revealTitle(revealed.email)}</h3>
      <p className="password-reveal-value num" data-testid="revealed-password">
        {revealed.password}
      </p>
      <p className="settings-hint measure">{MEMBER_PASSWORD_COPY.revealNote}</p>
      <div className="password-reveal-actions">
        <Button variant="primary" onClick={() => void copyPassword()}>
          {MEMBER_PASSWORD_COPY.copy}
        </Button>
        <Button onClick={onDismiss}>{MEMBER_PASSWORD_COPY.dismiss}</Button>
        {copy === 'idle' ? null : (
          <span role="status" className={copy === 'copied' ? 'text-tone tone-success' : 'text-tone tone-danger'}>
            {copy === 'copied' ? MEMBER_PASSWORD_COPY.copied : MEMBER_PASSWORD_COPY.copyFailed}
          </span>
        )}
      </div>
    </section>
  )
}
